export const disableTab = (html: string): string => {
  const tempDiv = document.createElement('div');
  // eslint-disable-next-line no-unsanitized/property
  tempDiv.innerHTML = html;
  const elements = tempDiv.querySelectorAll(
    'a, button, input, select, textarea, [tabindex]',
  );
  elements.forEach((element) => {
    element.setAttribute('tabindex', '-1');
  });
  return tempDiv.innerHTML;
};
